// extracted by mini-css-extract-plugin
export default {"btn":"ButtonLittleApp_btn__tLBp6","green":"ButtonLittleApp_green__emRqM","blue":"ButtonLittleApp_blue__Z34wr","red":"ButtonLittleApp_red__YZHxN"};